// extracted by mini-css-extract-plugin
module.exports = {"container":"color-picker_container__2Gddr","color":"color-picker_color__36dLG","selected":"color-picker_selected__2wdeA"};